import { render, staticRenderFns } from "./ShowFeedbacks.vue?vue&type=template&id=60288221&"
import script from "./ShowFeedbacks.vue?vue&type=script&lang=js&"
export * from "./ShowFeedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports